const django = window.djangoData;
for (const key of Object.keys(django.data)) {
    django[key] = django.data[key];
}
delete django.data;

export default django;
